import { Flex, Td, Text, Tr } from "@chakra-ui/react";
import { IncompleteFileUpload, IncompleteFileUploadStatus } from "../../../../common/documents/UppyUploader/FileRow";
import { ProgressBar } from "../../../../common/documents/UppyUploader/ProgressBar";
import { RemoveFileButton } from "../../../../common/documents/UppyUploader/RemoveFileButton";

interface Props {
  file: IncompleteFileUpload;
  name: string;
  remove: (file: IncompleteFileUpload) => Promise<void>;
}

export const UploadRow = ({ file, name, remove }: Props) => {
  return (
    <>
      <Tr>
        <Td borderBottom="none" pb="2" pl="0">
          <Text fontSize={"sm"}>{name}</Text>
        </Td>
        <Td borderBottom="none" pb="2" pr="0">
          <Flex justifyContent="end">
            <RemoveFileButton
              confirmRemoval={async () => {
                await remove(file);
              }}
            />
          </Flex>
        </Td>
      </Tr>
      <Tr>
        <Td borderBottom="none" colSpan={2} pt="0" px="0">
          <ProgressBar
            status={file.status}
            rejectedByScan={file.status === IncompleteFileUploadStatus.UploadFailed && !!file.rejectedByScan}
          />
        </Td>
      </Tr>
    </>
  );
};
